export default [
  {
    path: "/enterprise/transaction",
    name: "PaymentsCustomerTransaction",
    component: () => import("@/views/EnterpriseCustomer/Payments/Transactions.vue"),
  },
  {
    path: "/payments",
    name: "Payments",
    component: () => import("@/views/EnterpriseCustomer/Payments/Payments.vue"),
  },
  {
    path: "/payments/cards",
    name: "Cards",
    component: () => import("@/views/EnterpriseCustomer/Payments/Cards.vue"),
  },
  {
    path: "/payments/wallet",
    name: "Wallet",
    component: () => import("@/views/EnterpriseCustomer/Payments/Wallet.vue"),
  },
  {
    path: "/payments/account-statement/:name",
    name: "AccountStatement",
    component: () => import("@/views/EnterpriseCustomer/Payments/AccountStatement.vue"),
  },
  {
    path: "/payments/all-wallet",
    name: "AllWallet",
    component: () => import("@/views/Ondemand/Payments/AllWallet.vue"),
  },
];

